import React, { useState, useEffect } from "react";
import Routes from "./routes";
import "react-toastify/dist/ReactToastify.css";

import { createTheme, ThemeProvider } from "@material-ui/core/styles";
import { ptBR } from "@material-ui/core/locale";
import { WhiteLabelProvider } from "./context/WhiteLabel/WhiteLabelContext";
import ModuleErrorBoundary from "./components/ModuleErrorBoundary";

const App = () => {
  const [locale, setLocale] = useState();

  const theme = createTheme(
    {
      scrollbarStyles: {
        "&::-webkit-scrollbar": {
          width: "8px",
          height: "8px",
        },
        "&::-webkit-scrollbar-thumb": {
          boxShadow: "inset 0 0 6px rgba(0, 0, 0, 0.3)",
          backgroundColor: "#e8e8e8",
        },
      },
      palette: {
        primary: { main: "#2576d2" },
      },
    },
    locale
  );

  useEffect(() => {
    const i18nlocale = localStorage.getItem("i18nextLng") || "";
    const browserLocale =
      i18nlocale.substring(0, 2) + i18nlocale.substring(3, 5);

    if (browserLocale === "ptBR") {
      setLocale(ptBR);
    }
  }, []);

  return (
    <ThemeProvider theme={theme}>
      {/* Red de la red. No reemplaza a los boundaries de módulo: es lo que
          convierte una pantalla EN BLANCO (React desmontando el árbol entero)
          en un mensaje con un botón de recargar. Todo lo que está arriba del
          boundary de rutas — el layout, el menú, los providers — sólo tiene
          este. */}
      <ModuleErrorBoundary module="app" variant="app">
        <WhiteLabelProvider>
          <Routes />
        </WhiteLabelProvider>
      </ModuleErrorBoundary>
    </ThemeProvider>
  );
};

export default App;
